<section class="flex flex--column g-large" data-testid="cms-ond-faqs">
  @if (title()) {
    <h2
      class="faq-title nordic-blue-900-text text-icon-primary font-heading-2 font-headline-small mr-clear-t mr-clear-b"
    >
      {{ title() }}
    </h2>
  }

  @for (faq of faqs(); track faq.contentId) {
    <div
      class="faq-item white-bg surface-primary rounded-large elevation-level-1 ps-medium-x ps-xsmall-y"
      data-testid="cms-ond-faqs-item"
    >
      <div class="flex flex--align-start">
        <fcom-icon
          class="flex--nogrow ms-large-r icon-medium nordic-blue-900-text text-icon-primary"
          [name]="SvgLibraryIcon.SINGLE_PAX"
        />
        <h3
          class="nordic-blue-900-text text-icon-primary font-body-1 medium-type font-label-medium mr-clear-y"
          data-testid="cms-ond-faqs-question"
        >
          {{ faq.teaserTitle }}
        </h3>
      </div>
      <div class="flex flex--align-start mr-xsmall-t">
        <fcom-icon
          class="flex--nogrow ms-large-r icon-medium nordic-blue-900-text text-icon-primary"
          [name]="SvgLibraryIcon.FINNAIR_EMBLEM"
        />
        <div
          class="faq-answer flex-1 nordic-blue-900-text text-icon-primary font-body-1 font-body-medium"
          data-testid="cms-ond-faqs-answer"
          [innerHTML]="faq.teaserText"
        ></div>
      </div>
    </div>
  }
</section>
